import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';
import { Article } from '../models/article/article';
import { UnreadArticles } from '../models/article/unread-articles';

@Injectable()
export class ArticleService {
    constructor(private http: HttpClient, private configService: ConfigService) {
    }

    getArticles(page: number): Observable<Article[]> {
        let params = new HttpParams();
        if (page) {
            params = params.set('page', page.toString());
        }

        return this.http.get<Article[]>(`${ this.configService.baseUrl }/articles`, {params});
    }

    getArticle(reference: string): Observable<Article> {
        return this.http.get<Article>(`${ this.configService.baseUrl }/articles/${ reference }`);
    }

    getUnreadAnnouncements() : Observable<UnreadArticles> {
        return this.http.get<UnreadArticles>(`${ this.configService.baseUrl }/articles/announcements`);
    }

    markAnnouncementRead(reference: string) : Observable<UnreadArticles> {
        return this.http.post<UnreadArticles>(`${ this.configService.baseUrl }/articles/announcements/${ reference }/read`, null);
    }
}
